<template>
    <div class="field">
        <label>{{ field.label || field.field_name }}</label>
        <template>
            <select
                v-if="field.type === 'user'"
                class="form-control"
                v-model="v"
            >
                <option value="">{{ t('custom_fields-select_user') }}</option>
                <option
                    v-for="(user, index) in field.options"
                    :value="user.value"
                    :key="index"
                >
                    {{ user.label }}
                </option>
            </select>
            <datetime-with-clear
                v-else-if="field.type === 'date'"
                type="date"
                :flow="['year', 'month', 'date']"
                value-zone="America/Sao_Paulo"
                v-model="v"
            ></datetime-with-clear>
            <textarea
                v-else-if="field.type === 'textarea'"
                class="form-control"
                v-model="v"
                :placeholder="field.placeholder || ''"
                rows="4"
            />
            <input
                v-else-if="field.type === 'checkbox'"
                type="checkbox"
                class="form-check-input"
                v-model="v"
            />
            <input
                v-else
                :type="inputType"
                class="form-control"
                v-model="v"
                :placeholder="field.placeholder || ''"
            />
        </template>
    </div>
</template>
<script>
import { mapState } from "vuex";
import DatetimeWithClear from "../datetime-with-clear/datetime-with-clear.vue";

export default {
    name: "custom-field",
    props: {
        /** @type {CustomField} */
        field: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: null,
            default: "",
        },
    },
    components: {
        "datetime-with-clear": DatetimeWithClear,
    },
    computed: {
        ...mapState({
            users: (state) => state.users,
        }),
    },
    data() {
        return {
            v: this.value,
        };
    },
    computed: {
        inputType() {
            switch (this.field?.type) {
                case "password":
                    return "password";
                case "number":
                    return "number";
                case "email":
                    return "email";
                case "tel":
                    return "tel";
                default:
                    return "text";
            }
        },
    },
    watch: {
        v() {
            this.$emit("input", this.v);
        },
        value() {
            if (this.value !== this.v) {
                this.v = this.value;
            }
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
